import React, { useState } from "react";
import { deleteTimetableDay } from "../../services/adminTimeTableServices";
import SessionTable from "./SessionTable";

const TimetableDayAccordion = ({ day, reload }) => {
  const [open, setOpen] = useState(false);

  // Delete day handler
  const handleDeleteDay = async (e) => {
    e.stopPropagation(); // prevent accordion toggle
    if (!window.confirm("Delete this day and all sessions?")) return;

    try {
      await deleteTimetableDay(day.id);
      reload();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to delete day");
    }
  };

  return (
    <div className="accordion">
      <div className="accordion-header" onClick={() => setOpen(!open)}>
         <strong>{day.localDate}</strong>
        <button onClick={handleDeleteDay}>🗑️</button>
      </div>

      {open && (
        <div className="accordion-body">
          <SessionTable
            dayId={day.id}
            dayDate={day.localDate}
            sessions={day.sessions}
            reload={reload}
          />
        </div>
      )}
    </div>
  );
};

export default TimetableDayAccordion;
